import { render, staticRenderFns } from "./CreateTaskTemplateModal.vue?vue&type=template&id=3bb22312&scoped=true&"
import script from "./CreateTaskTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateTaskTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTaskTemplateModal.vue?vue&type=style&index=0&id=3bb22312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb22312",
  null
  
)

export default component.exports